const MembershipBannerHeading = () => (
  <h3
    className="text-autumn text-xl font-medium leading-7 tracking-[0.4px]"
    data-testid="membership-banner-heading"
  >
    Become a member today
  </h3>
)

export default MembershipBannerHeading
